import { useLoomThumbnailUrl } from '@atlassian/company-hub-common/use-loom-thumbnail-url';

const hasValidUrl = (s: string | undefined) => !!s && s.trim() !== '';

/**
 * Resolves the image URL to display for a card (cover/thumbnail).
 * Delegates to source-specific hooks (e.g. Loom); when no source matches,
 * returns the stored imageData. Returns empty string when there is no image to show.
 */
export const useResolveImage = (
	link: string | undefined,
	imageData: string | undefined,
): string => {
	const loomThumbnailUrl = useLoomThumbnailUrl(link, imageData);

	const hasResolved = hasValidUrl(loomThumbnailUrl);
	const hasStored = hasValidUrl(imageData);
	if (hasResolved || hasStored) {
		return loomThumbnailUrl ?? imageData ?? '';
	}

	return '';
};
